import { ExportType } from '@fides/fides-react-components';

export const FILE_TYPE = {
  CSV: {
    contentType: 'application/csv;base64',
    mapFileName: (fileName) => `${fileName}.csv`,
    value: 'CSV',
  },
  TXT: {
    contentType: 'data:application/txt;base64',
    mapFileName: (fileName) => `${fileName}.txt`,
    value: 'TXT',
  },
  // N.B. ZIP, PDF files type must be downloaded with: config.responseType = 'arraybuffer'
  // e.g. HTTPService.useBinaryGetHandler or AccountService.getBinaryUserReport:
  ZIP: {
    contentType: 'application/zip',
    mapFileName: (fileName) => `${fileName}.zip`,
    value: 'ZIP',
  },
  PDF: {
    contentType: 'application/pdf',
    mapFileName: (fileName) => `${fileName}.pdf`,
    value: 'PDF',
  },
  XLSX: {
    contentType: 'application/xlsx',
    mapFileName: (fileName) => `${fileName}.xlsx`,
    value: 'XLSX',
  },
  XLS: {
    contentType: 'application/xlsx',
    mapFileName: (fileName) => `${fileName}.xlsx`,
    value: 'XLS',
  },
};

export const EXPORT_TYPE = {
  CSV: {
    value: 'CSV',
    method: 'downloadCSV',
  },
  XLSX: {
    value: 'XLSX',
    method: 'downloadXls',
  },
  XLS: {
    value: 'XLS',
    method: 'downloadXls',
  },
  PDF_ACCOUNT_OVERVIEW: {
    method: 'downloadPDF',
    url: '/accounts',
    value: 'PDF_ACCOUNT_OVERVIEW',
    prefix: 'Account_List_',
  },
};

export const TXT_TYPE = 'TXT';
export const PDF_TYPE = 'PDF';

export const DEFAULT_EXPORT_OPTIONS = [
  { label: ExportType.XLSX, value: ExportType.XLSX },
  { label: ExportType.CSV, value: ExportType.CSV },
];
